import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './ArticleContent.module.scss';

export default class ArticleContent extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  static defaultProps = {
    className: ''
  };

  render() {
    return (
      <article
        className={`${styles.ArticleContentComponent} ${
          styles.ComponentMargin
        }`}
      >
        {this.props.children}
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/components/Article/ArticleContent/ArticleContent.js